type OwnerLike = {
  id: string;
  name: string;
  displayName?: string;
};

type SelectOption = {
  value: string;
  label: string;
};

/**
 * 사용자/팀 데이터를 Select 옵션으로 변환
 */
export const transformOwnersToSelectOptions = (owners: OwnerLike[] | undefined): SelectOption[] => {
  if (!owners) return [];
  return owners.map((owner) => ({
    value: owner.id,
    label: owner.displayName || owner.name,
  }));
};
